import styled from 'styled-components';
import Theme from '../../../../shared/styles/Theme';

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: ${Theme.Size.Default};
`;
